import moment from 'moment';
import { getWeekRange, getWeekDays } from '@/helpers';
import * as labTypes from './types';

const initialState = {
  labEntries: {
    data: [],
    isLoading: false,
    selectedDays: getWeekDays(getWeekRange(moment()).from),
    oid: null,
  },
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case labTypes.GET_LAB_TIME_ENTRIES:
      return {
        ...state,
        labEntries: {
          ...state.labEntries,
          oid: action.oid || state.labEntries.oid,
          selectedDays: action.selectedDays || state.labEntries.selectedDays,
          isLoading:
            (action.isLoading !== false) || state.labEntries.isLoading,
          data: state.labEntries.data,
        },
      };

    case labTypes.GET_LAB_TIME_ENTRIES_SUCCESS:
      return {
        ...state,
        labEntries: {
          ...state.labEntries,
          data:
            action.payload.sort((a, b) =>
              a.requestNumber > b.requestNumber ? 1 : -1
            ) || [],
          isLoading: false,
        },
      };

    case labTypes.GET_LAB_TIME_ENTRIES_ERROR:
      return {
        ...state,
        labEntries: {
          ...state.labEntries,
          data: [],
          isLoading: false,
        },
      };

    case labTypes.UPSERT_LAB_TIME_ENTRY_SUCCESS: {
      return {
        ...state,
        labEntries: {
          ...state.labEntries,
          data: state.labEntries.data.map((lab) => {
            if (lab.requestId === action.payload.requestId) {
              return {
                ...lab,
                procedures: lab.procedures.map((procedure) => {
                  if (procedure.procedureId === action.payload.procedureId) {
                    return {
                      ...procedure,
                      timeEntries: [
                        ...procedure.timeEntries.filter((entry) => {
                          return entry.id !== action.payload.id;
                        }),
                        action.payload,
                      ],
                    };
                  }
                  return procedure;
                }),
              };
            }
            return lab;
          }),
        },
      };
    }

    case labTypes.DELETE_LAB_TIME_ENTRY_SUCCESS:
      return {
        ...state,
        labEntries: {
          ...state.labEntries,
          data: state.labEntries.data.map((lab) => ({
            ...lab,
            procedures: lab.procedures.map((procedure) => ({
              ...procedure,
              timeEntries: procedure.timeEntries.filter(
                (entry) => entry.timeEntry.id !== action.payload
              ),
            })),
          })),
        },
      };

    case labTypes.ADD_LAB_ENTRY: {
      const index = state.labEntries.data.findIndex(
        (lab) => lab.requestId === action.payload.requestId
      );

      const updatedData = [...state.labEntries.data];

      if (index !== -1) {
        // already exists
        const newObj = { ...action.payload };

        const combinedProcedures = [
          ...updatedData[index].procedures,
          ...action.payload.procedures,
        ];

        const uniqueProcedures = combinedProcedures.reduce((acc, procedure) => {
          if (!acc.some(p => p.procedureId === procedure.procedureId)) {
            acc.push(procedure);
          }
          return acc;
        }, []);

        newObj.procedures = uniqueProcedures.sort((a, b) => {
          if (a.procedureAlphaId < b.procedureAlphaId) return -1;
          if (a.procedureAlphaId > b.procedureAlphaId) return 1;
          return 0;
        });

        updatedData[index] = newObj;
      } else {
        updatedData.push(action.payload);
      }

      return {
        ...state,
        labEntries: {
          ...state.labEntries,
          data: updatedData,
        },
      };
    }

    case labTypes.DELETE_LAB_ENTRY: {
      const index = state.labEntries.data.findIndex(
        (lab) => lab.requestId === action.payload.requestId
      );

      if (index === -1) {
        return state;
      }

      const updatedData = [...state.labEntries.data];
      const existing = updatedData[index];

      const newProcedures = existing.procedures.filter(
        (p) => p.procedureId !== action.payload.procedures[0].procedureId
      );

      if (newProcedures.length === 0) {
        updatedData.splice(index, 1);
      } else {
        updatedData[index] = {
          ...existing,
          procedures: newProcedures,
        };
      }

      return {
        ...state,
        labEntries: {
          ...state.labEntries,
          data: updatedData,
        },
      };
    }

    case labTypes.CREATE_LAB_TIME_ENTRY_ERROR:
    case labTypes.UPSERT_LAB_TIME_ENTRY_ERROR:
    case labTypes.UPDATE_LAB_TIME_ENTRY_ERROR:
    case labTypes.DELETE_LAB_TIME_ENTRY_ERROR:
    default:
      return state;
  }
};
